module.exports = __webpack_public_path__ + "static/media/package_dev_turn_key_plain.7eed4c6c.svg";